import CaptchaService from "@services/captcha/CaptchaService";
import {
	httpClient,
	getAgencyKey,
	getShopId,
	getApplicationHeaders,
} from "@utils";

const baseUrl = `${WEBPACK_BASE_ADDRESS}platform/contact-support/`;

class ContactServiceData {
	getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	async sendInquiry(contact: {
		shopId: string;
		agencyId: string;
		challengeResponse: string;
	}) {
		contact.shopId = getShopId();
		contact.agencyId = getAgencyKey();

		const token = await CaptchaService.executeCaptcha("contact");

		if (token) {
			contact.challengeResponse = token;
		}

		return await httpClient.post(
			baseUrl,
			JSON.stringify(contact),
			this.getRequestHeaders()
		);
	}
}

export const contactServiceData = new ContactServiceData();
